import { useState, useEffect } from 'react';
import { getAdminUsers, createAdminUser, unlockUser } from '../services/api';

export default function AdminUsersPage() {
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [error, setError] = useState('');
  const [creating, setCreating] = useState(false);

  const load = () => getAdminUsers().then(setUsers).catch(() => {});
  useEffect(() => { load(); }, []);

  const handleCreate = async (e) => {
    e.preventDefault();
    setError('');
    setCreating(true);
    try {
      await createAdminUser({ email, password, isAdmin });
      setEmail('');
      setPassword('');
      setIsAdmin(false);
      await load();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create user');
    } finally {
      setCreating(false);
    }
  };

  const handleUnlock = async (id) => {
    await unlockUser(id);
    await load();
  };

  return (
    <div>
      <h2>Users</h2>

      <div className="card" style={{ marginBottom: '1.5rem' }}>
        <h3 style={{ marginTop: 0 }}>Create user</h3>
        <form onSubmit={handleCreate} style={{ display: 'flex', gap: 12, flexWrap: 'wrap', alignItems: 'flex-end' }}>
          <div>
            <label htmlFor="new-user-email" style={{ display: 'block', fontSize: 13, marginBottom: 4 }}>Email</label>
            <input
              id="new-user-email"
              name="username"
              type="email"
              autoComplete="off"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label htmlFor="new-user-password" style={{ display: 'block', fontSize: 13, marginBottom: 4 }}>Password</label>
            <input
              id="new-user-password"
              name="new-password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={12}
            />
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <input type="checkbox" checked={isAdmin} onChange={(e) => setIsAdmin(e.target.checked)} />
            Admin
          </label>
          <button type="submit" className="btn-primary" disabled={creating}>
            {creating ? 'Creating…' : 'Create'}
          </button>
        </form>
        {error && <p className="error" style={{ marginTop: 8 }}>{error}</p>}
      </div>

      <div className="table-scroll">
        <table>
          <thead>
            <tr>
              <th>Email</th>
              <th>Admin</th>
              <th>2FA</th>
              <th>Last login</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => {
              const locked = u.locked_until && new Date(u.locked_until) > new Date();
              return (
                <tr key={u.id}>
                  <td>{u.email}</td>
                  <td>{u.is_admin ? 'Yes' : 'No'}</td>
                  <td>{u.two_factor_enabled ? 'Enabled' : '—'}</td>
                  <td>{u.last_login ? new Date(u.last_login).toLocaleString() : 'Never'}</td>
                  <td>{locked ? 'Locked' : 'Active'}</td>
                  <td>{locked && (
                    <button className="btn-secondary" onClick={() => handleUnlock(u.id)}>Unlock</button>
                  )}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
